<template>
    <div>
        <v-layout row wrap>
            <v-flex md5>
                <v-select
                    single-line
                    item-value=id
                    item-text=name
                    :items="activeTeamsForSelect"
                    outline
                    label="Team"
                    @input="changeTeam">

                </v-select>
            </v-flex>
        </v-layout>

        <v-container >
            <v-layout child-flex>
                <v-data-table
                        :headers="recordHeaders"
                        :items="recordItems"                  
                        hide-actions>
                    <template slot="headers" slot-scope="props">
                        <tr>
                            <th
                                v-for="header in props.headers"
                                :key="header.text">
                                <b>{{ header.text }}</b>
                            </th>
                        </tr>
                    </template>
                    <template slot="items" slot-scope="props">
                        <tr :key="props.index">
                            <!-- <td >{{ props.item.bowler_scratch_game[0].bowler + " " + props.item.bowler_scratch_game[0].high_game + " " + getPrettyDates(props.item.bowler_scratch_game[0].date) }}</td> -->
                            <td>
                                <v-flex><b> {{props.item.bowler_scratch_game[0].high_game}} </b></v-flex>
                                <v-flex> {{ props.item.bowler_scratch_game[0].bowler }}</v-flex>
                                <v-flex> {{getPrettyDates(props.item.bowler_scratch_game[0].date) }}</v-flex>
                            </td>
                            <td>
                                <v-flex><b> {{props.item.bowler_hdcp_game[0].hdcp_game}} </b></v-flex>
                                <v-flex> {{ props.item.bowler_hdcp_game[0].bowler }}</v-flex>
                                <v-flex> {{getPrettyDates(props.item.bowler_hdcp_game[0].date) }}</v-flex>
                            </td>
                            <td>
                                <v-flex><b> {{props.item.bowler_scratch_series[0].series}} </b></v-flex>
                                <v-flex> {{ props.item.bowler_scratch_series[0].bowler }}</v-flex>
                                <v-flex> {{getPrettyDates(props.item.bowler_scratch_series[0].date) }}</v-flex>
                            </td>
                            <td>
                                <v-flex><b> {{props.item.bowler_hdcp_series[0].hdcp_series}} </b></v-flex>
                                <v-flex> {{ props.item.bowler_hdcp_series[0].bowler }}</v-flex>
                                <v-flex> {{getPrettyDates(props.item.bowler_hdcp_series[0].date) }}</v-flex>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-layout>
        </v-container>
        <v-container >
            <v-layout child-flex>
                <v-data-table
                        :headers="teamRecordHeaders"
                        :items="recordItems"                  
                        hide-actions>
                    <template slot="headers" slot-scope="props">
                        <tr>
                            <th
                                v-for="header in props.headers"
                                :key="header.text">
                                <b>{{ header.text }}</b>
                            </th>
                        </tr>
                    </template>
                    <template slot="items" slot-scope="props">
                        <tr :key="props.index">
                            <td>
                                <v-flex><b> {{props.item.team_scratch_game[0].high_game}} </b></v-flex>
                                <v-flex> {{getPrettyDates(props.item.team_scratch_game[0].date) }}</v-flex>
                            </td>
                            <td>
                                <v-flex><b> {{props.item.team_hdcp_game[0].hdcp_game}} </b></v-flex>
                                <v-flex> {{getPrettyDates(props.item.team_hdcp_game[0].date) }}</v-flex>
                            </td>
                            <td>
                                <v-flex><b> {{props.item.team_scratch_series[0].total_scratch}} </b></v-flex>
                                <v-flex> {{getPrettyDates(props.item.team_scratch_series[0].date) }}</v-flex>
                            </td>
                            <td>
                                <v-flex><b> {{props.item.team_hdcp_series[0].total_hdcp}} </b></v-flex>
                                <v-flex> {{getPrettyDates(props.item.team_hdcp_series[0].date) }}</v-flex>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-layout>
        </v-container>
        
        <v-container fluid>
            <v-layout child-flex>
                <v-data-table
                        :headers="headers"
                        :items="items"
                        :rows-per-page-items="[10,25,100, {'text':'All','value':-1}]"
                        :pagination.sync="pagination">
                    <template slot="headers" slot-scope="props">
                        <tr>
                            <th
                                v-for="header in props.headers"
                                :key="header.text">
                                {{ header.text }}
                            </th>
                        </tr>
                    </template>
                    <template slot="items" slot-scope="props">
                        <tr :key="props.index">
                            <td >{{ getPrettyDates(props.item.date)}}</td>
                            <td >{{ props.item.g1_scratch }}</td>
                            <td >{{ props.item.g1_hdcp }}</td>
                            <td >{{ props.item.g1_over_under }}</td>
                            <td >{{ props.item.g2_scratch }}</td>
                            <td >{{ props.item.g2_hdcp }}</td>
                            <td >{{ props.item.g2_over_under }}</td>
                            <td >{{ props.item.g3_scratch }}</td>
                            <td >{{ props.item.g3_hdcp }}</td>
                            <td >{{ props.item.g3_over_under }}</td>
                            <td >{{ props.item.total_scratch }}</td>
                            <td >{{ props.item.total_hdcp }}</td>
                            <td >{{ props.item.total_over_under }}</td>
                            <td >{{ props.item.game1 }}</td>
                            <td >{{ props.item.game2 }}</td>
                            <td >{{ props.item.game3 }}</td>
                            <td >{{ props.item.totals }}</td>
                            <td >{{ props.item.points }}</td>
                            <td >{{emptyIfNull(props.item.additional_scratch)}}</td>
                            <td >{{emptyIfNull(props.item.additional_hdcp)}}</td>
                        </tr>
                    </template>
                    <template slot="footer">
                        <tr class="blue--text">
                            <th >Totals</th>
                            <th >{{ average('g1_scratch').toFixed(0) }}</th>
                            <th >{{ average('g1_hdcp').toFixed(0) }}</th>
                            <th >{{ average('g1_over_under').toFixed(0) }}</th>
                            <th >{{ average('g2_scratch').toFixed(0) }}</th>
                            <th >{{ average('g2_hdcp').toFixed(0) }}</th>
                            <th >{{ average('g2_over_under').toFixed(0) }}</th>
                            <th >{{ average('g3_scratch').toFixed(0) }}</th>
                            <th >{{ average('g3_hdcp').toFixed(0) }}</th>
                            <th >{{ average('g3_over_under').toFixed(0) }}</th>
                            <th >{{ average('total_scratch').toFixed(0) }}</th>
                            <th >{{ average('total_hdcp').toFixed(0) }}</th>
                            <th >{{ average('total_over_under').toFixed(0) }}</th>
                            <th >{{ countWLT('game1') }} </th>
                            <th >{{ countWLT('game2') }} </th>
                            <th >{{ countWLT('game3') }}</th>
                            <th >{{ countWLT('totals') }}</th>
                            <th >{{ sumField('points') }}</th>
                        </tr>
                    </template>
                </v-data-table>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
   import axios from "axios";
   export default {
      components: {
      },
      name: 'TeamOutingsTable',
      data() {
         return {
            pagination : {
               'sortBy': 'date',
               'descending': false,
               'rowsPerPage': -1
            },
            items: [],
            recordItems: [],
         }
      },
      computed: {
         activeTeamsForSelect(){
            return this.$store.getters.activeTeams.map(this.dbTeamToFrontendTeam);
         },

         recordHeaders(){
             return [
                 {text: "Bowler Scratch Game", value: 'bowler_scratch_game'},
                 {text: "Bowler HDCP Game", value: 'bowler_hdcp_game'},
                 {text: "Bowler Scratch Series", value: 'bowler_scratch_series'},
                 {text: "Bowler HDCP Series", value: 'bowler_hdcp_series'},
             ]
         },
         teamRecordHeaders(){
             return [
                 {text: "Team Scratch Game", value: 'team_scratch_game'},
                 {text: "Team HDCP Game", value: 'team_hdcp_game'},
                 {text: "Team Scratch Series", value: 'team_scratch_series'},
                 {text: "Team HDCP Series", value: 'team_hdcp_series'},
             ]
         },
         /**
          * Returns a list of table column headers that is conditional based on whether we're in mobile or
          * desktop mode.
          * @returns {*[]}
          */
         headers() {
           return [
              { text: 'Date', value: 'date' },
              { text: 'G1 Scratch', value: 'g1_scratch' },
              { text: 'G1 Hdcp', value: 'g1_hdcp' },
              { text: 'G1 +/-', value: 'g1_over_under' },
              { text: 'G2 Scratch', value: 'g2_scratch' },
              { text: 'G2 Hdcp', value: 'g2_hdcp' },
              { text: 'G2 +/-', value: 'g2_over_under' },
              { text: 'G3 Scratch', value: 'g3_scratch' },
              { text: 'G3 Hdcp', value: 'g3_hdcp' },
              { text: 'G3 +/-', value: 'g3_over_under' },
              { text: 'Total Scratch', value: 'total_scratch' },
              { text: 'Total Hdcp', value: 'total_hdcp' },
              { text: 'Total +/-', value: 'total_over_under' },
              { text: 'G1', value: 'game1' },
              { text: 'G2', value: 'game2' },
              { text: 'G3', value: 'game3' },
              { text: 'Totals', value: 'totals' },
              { text: 'Points', value: 'points' },
              { text: 'Scratch Adj', value: 'additional_scratch' },
              { text: 'Hdcp Adj', value: 'additional_hdcp' }
           ]
         }
      },
      methods:{
         emptyIfNull(v){
            return v ? v: "";
         },
         dbTeamToFrontendTeam(t){
            return {
               name: `${t.name} (${t.year} ${t.season})`,
               id: t.id
            }
         },
         sortTable(){
            this.items.sort((a,b) => {
              const aD = new Date(a.date);
              const bD = new Date(b.date);
              return aD>bD ? -1 : aD<bD ? 1 : 0;
           });
         },
         isBadScore(v, n){
            return v <= n;
         },
         isGoodScore(v,n ){
            return v >= n;
         },
         toggleDialog(){
            this.dialog = !this.dialog;
         },
         getData: async function(id){
            this.items = [];
            console.log("Getting bowler history...");
            let URL = "https://nostyleguy.com/api/team_results/" +
               id.toString();
            await axios({
                method: "GET",
                url: URL
            }).then(
               result => {
                  for(let i in result.data){
                     console.log("Got: " + JSON.stringify(result.data[i]));
                     this.items.push(result.data[i]);
                     this.sortTable();
                  }
               },
               error => {
                  console.log("Error: " + error);
               }
            );
            this.sortTable();

            this.recordItems = [];
            console.log("Getting bowler history...");
            URL = "https://nostyleguy.com/api/team_records/" + id.toString();
            await axios({
                method: "GET",
                url: URL
            }).then(
               result => {
                   this.recordItems.push(result.data);
               },
               error => {
                  console.log("Error: " + error);
               }
            );
         },
         getPrettyDates(history){
            const date = new Date(history);
            const monthNames = [
               "January", "February", "March",
               "April", "May", "June", "July",
               "August", "September", "October",
               "November", "December"
            ];

            const day = date.getDate();
            const monthIndex = date.getMonth();
            const year = date.getFullYear();

            return day + ' ' + monthNames[monthIndex].slice(0,3) + ' ' + year;
         },
         changeTeam(i){
            console.log("Selected Team: " + i);
            this.getData(i);
         },
         sumField(key){
            // sum data in give key (property)
            let total = this.items.reduce((a, b) => a + (b[key] || 0), 0);
            console.log("summing: " + key + " : " + total);
            return total;
        },
        countWLT(key){
            // sum data in give key (property)
            let total = this.items.reduce((a, b) => 
                a + ( b[key] == 'W' ? 1.0 : (b[key] == 'T' ? 0.5 : 0.0)), 0.0);

            console.log("summingWLT: " + key + " : " + total);
            return total;
        },
        average(key){
            // sum data in give key (property)
            return this.items.reduce(function (avg, value, _, { length }) {
                return avg + value[key] / length; }, 0);
        }
      },
      mounted: function () {
         this.$store.dispatch('getTeams');
      }
   }
</script>

<style scoped>


table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    text-align: center;
    padding: 0 10px;
    vertical-align: middle;
    height: 30px;
}

.table-header /deep/ {
    thead {
        background-color: black;
    }
}

table.v-table thead tr  {
    background-color: #548bde;
}

tr.border_bottom td {
    border-top:1pt solid black;
}

.badScore {
    background-color: #d32d41;
}
.goodScore {
    background-color: #5ed353;
}
.badSeries {
    background-color: #9b2231;
}
.goodSeries {
    background-color: #5d934c;
}
</style>
